import { post } from "../axios";
// import wx from "weixin-js-sdk";
import wx from 'weixin-jsapi'


const wxapi = {
  // wx配置
  getWxConfig() {
    post(`member/wechat/getSignInfo`, {
      // url: location.href.split("#")[0]
      url: window.location.protocol + '//' + window.location.host + '/'
    }).then(res => {
      wx.config({
        debug: false,
        appId: res.appid,
        timestamp: res.timestamp,
        nonceStr: res.noncestr,
        signature: res.signature,
        jsApiList: ["chooseWXPay"]
      });
    });
  },
  // 会员卡充值下单
  placeRechargeOrder({ id }) {
      return new Promise((resolve, reject) => {
          post("member/card/placeRechargeOrder", { id }).then(res => {
            wx.chooseWXPay({
              appId: res.appId,
              timestamp: res.timeStamp,
              nonceStr: res.nonceStr,
              package: res.package,
              signType: res.signType,
              paySign: res.paySign,
              success: function() {
                  resolve()
              }
            });
          });
      })
  },
  // 会员卡更换卡下单
  placeCardOrder({ id }) {
      return new Promise((resolve, reject) => {
          post("member/card/placeCardOrder", { id }).then(res => {
            wx.chooseWXPay({
              appId: res.appId,
              timestamp: res.timeStamp,
              nonceStr: res.nonceStr,
              package: res.package,
              signType: res.signType,
              paySign: res.paySign,
              success: function() {
                  resolve()
              }
            });
          });
      })
  },
  // 套餐充值下单
  placePackageOrder({ id }) {
      return new Promise((resolve, reject) => {
          post("member/card/placePackageOrder", { id }).then(res => {
            wx.chooseWXPay({
              appId: res.appId,
              timestamp: res.timeStamp,
              nonceStr: res.nonceStr,
              package: res.package,
              signType: res.signType,
              paySign: res.paySign,
              success: function() {
                  resolve()
              }
            });
          });
      })
  },
};

export default wxapi



// WEBPACK FOOTER //
// ./src/Interface/api/wxapi.js